var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsTeradata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10620_25809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.16667 0 0 10.3583 0 22.1467C0 34.5217 9.16667 44 22 44C34.8333 44 44 34.5217 44 22.1467C44 10.3583 34.8333 0 22 0ZM15.5283 6.30667H21.945V12.2833H28.5083V17.5267H21.945V27.0967C21.945 29.9933 23.3567 31.2583 25.4833 31.2583C26.2533 31.2583 27.28 31.0383 28.2517 30.6717C28.9483 32.505 30.1767 34.155 31.4967 35.475C29.5408 36.6282 27.3139 37.2419 25.0433 37.2533C19.3233 37.2533 15.5283 34.2283 15.5283 27.5733V6.325V6.30667Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10620_25809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsTeradata);
export default __webpack_public_path__ + "static/media/simple-icons_teradata.79146f745c58d6ba28b012e2d80a7653.svg";
export { ForwardRef as ReactComponent };